import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography, Box, Stack } from '@mui/material';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import { createNewDate, culture, options } from '../../../Helpers/dates';

const LeadOriginInfoWidget = function LeadOriginInfoWidget({
  leadOrigin,
  createdOn,
  leadDescription,
}) {
  const intl = useIntl();

  return (
    <Stack spacing={2} sx={{ padding: '16px' }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}>
        <PersonSearchRoundedIcon />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column"
          }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px",
              color: "primary.main",
              textTransform: "uppercase",
              fontWeight: "bold"
            }}>
            {intl.messages.LEAD_ORIGIN}
          </Typography>
          <Typography variant="body1" sx={{
            fontSize: "16px"
          }}>
            {leadOrigin}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}>
        <CalendarTodayRoundedIcon />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column"
          }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px",
              color: "primary.main",
              textTransform: "uppercase",
              fontWeight: "bold"
            }}>
            {intl.messages.CREATEDON}
          </Typography>
          <Typography variant="body1" sx={{
            fontSize: "16px"
          }}>
            {createNewDate(createdOn).toLocaleDateString(culture, options)}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}>
        <DescriptionRoundedIcon />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column"
          }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px",
              color: "primary.main",
              textTransform: "uppercase",
              fontWeight: "bold"
            }}>
            {intl.messages.DESCRIPTION}
          </Typography>
          <Typography variant="body1" sx={{
            fontSize: "16px"
          }}>
            {leadDescription}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

LeadOriginInfoWidget.propTypes = {
  leadOrigin: PropTypes.string.isRequired,
  createdOn: PropTypes.string.isRequired,
  leadDescription: PropTypes.string.isRequired,
};
export default LeadOriginInfoWidget;

/**<Box
      style={{
        overflow: 'auto',
        padding: '16px 24px',
        display: 'flex',
        gap: '4px',
        flexDirection: 'column',
        textOverflow: 'ellipsis',
      }}
    >
      <Typography
        noWrap
        variant="h6"
        sx={{
          fontSize: '14px',
          color: (theme) => theme.palette.grey.darker,
        }}
      >
        {`${intl.messages.LEAD_ORIGIN}: ${leadOrigin}`}
      </Typography>
      <Typography
        noWrap
        variant="h6"
        sx={{
          fontSize: '14px',
          color: (theme) => theme.palette.grey.darker,
        }}
      >
        {`${intl.messages.CREATEDON}: ${createNewDate(
          createdOn
        ).toLocaleDateString(culture, options)}`}
      </Typography>
      <Divider variant="middle" />
      <Typography
        noWrap
        variant="h6"
        sx={{
          fontSize: '14px',
          color: (theme) => theme.palette.grey.darker,
        }}
      >
        {`${intl.messages.DESCRIPTION} ${intl.messages.LEAD}: ${leadDescription}`}
      </Typography>
    </Box> */
